import React, { useState, useEffect } from 'react';
import { PER_TYPES, REVENUE_TYPES } from '../../../constants';
import type { IFilter, IPerType, IRevenueType } from '../../../types';

type IFlagNum = 1 | 2 | number;

interface IObserverBaseOption {
  perType: IPerType;
  revenueType: IRevenueType;
  filter: IFilter;
}

interface IObserverOption extends IObserverBaseOption {
  num: IFlagNum;
  setNum: React.Dispatch<React.SetStateAction<IFlagNum>>;
}

function toggleFlagNum(num: IFlagNum): IFlagNum {
  return num === 1 ? 2 : 1;
}

// TopGenrePerMarket Mobile 在regionType切换后，需要重新获取根据新的regionType重新获取最近搜索记录，并且重置搜索的状态
function useRefreshRecentSearchStateFlagMobilePerMarket(option: IObserverOption) {
  const { perType, revenueType, filter, num, setNum } = option;

  useEffect(() => {
    if (revenueType !== REVENUE_TYPES.MOBILE) return;
    if (perType !== PER_TYPES.MARKET) return;
    const numTmp = toggleFlagNum(num);
    setNum(numTmp);
  }, [perType, revenueType, filter?.regionType]);
}

// TopMarketPerGenre Mobile 在genreType切换后，需要重新获取根据新的genreType重新获取最近搜索记录，并且重置搜索的状态
function useRefreshRecentSearchStateFlagMobilePerGenre(option: IObserverOption) {
  const { perType, revenueType, filter, num, setNum } = option;

  useEffect(() => {
    if (revenueType !== REVENUE_TYPES.MOBILE) return;
    if (perType !== PER_TYPES.GENRE) return;
    const numTmp = toggleFlagNum(num);
    setNum(numTmp);
  }, [perType, revenueType, filter?.genreType]);
}

// TopGenrePerMarket 非Mobile 在regionType切换后，需要重新获取根据新的regionType重新获取最近搜索记录，并且重置搜索的状态
function useRefreshRecentSearchStateFlagNotMobilePerMarket(option: IObserverOption) {
  const { perType, revenueType, filter, num, setNum } = option;

  useEffect(() => {
    if (revenueType === REVENUE_TYPES.MOBILE) return;
    if (perType !== PER_TYPES.MARKET) return;
    const numTmp = toggleFlagNum(num);
    setNum(numTmp);
  }, [perType, revenueType, filter?.regionType]);
}

// 根据页面类型，分别开启不同的useEffect，但是一个页面类型，同时只会有一个useEffect会执行，非对应的页面类型的useEffect会在内部判断，提前return
export default function useRefreshRecentSearchStateFlag(option: IObserverBaseOption): IFlagNum {
  const [num, setNum] = useState<IFlagNum>(1);

  useRefreshRecentSearchStateFlagMobilePerMarket({ ...option, num, setNum });

  useRefreshRecentSearchStateFlagMobilePerGenre({ ...option, num, setNum });

  useRefreshRecentSearchStateFlagNotMobilePerMarket({ ...option, num, setNum });

  return num;
}
